import fetch from 'cross-fetch';
import {
	OAuthConfirmAction,
	OAuthConfirmResponse,
	OAuthLoginToGameAction,
	OAuthLoginToGameResponse,
	OAuthStartAction,
	OAuthStartResponse,
} from './oauth';
import { isWebPlatform } from '../../../components/forms/login-hub/common/login-hub-helpers';

const parseBody = async (response: Response) => {
	const text = await response.text();
	return text ? JSON.parse(text) : {};
};

export class RemoteOAuthStartAction {
	private readonly baseUrl: string | null;

	constructor(baseUrl: string | null) {
		this.baseUrl = baseUrl;
	}

	action: OAuthStartAction = async (provider: string, route: string): Promise<OAuthStartResponse> => {
		const base: string = this.baseUrl || '';
		const platform: string = isWebPlatform() ? 'web' : 'mobile';

		const response: Response = await fetch(`${base}/api/oauth/${provider}?platform=${platform}`, {
			mode: 'cors',
			credentials: 'include',
			method: 'GET',
			headers: {
				'X-Anchor': route,
			},
		});

		return { ...await parseBody(response), status: response.status };
	};
}

export class RemoteOAuthConfirmAction {
	private readonly baseUrl: string | null;

	constructor(baseUrl: string | null) {
		this.baseUrl = baseUrl;
	}

	action: OAuthConfirmAction = async (provider: string): Promise<OAuthConfirmResponse> => {
		const base: string = this.baseUrl || '';

		const response: Response = await fetch(`${base}/api/auth/${provider}/confirm`, {
			mode: 'cors',
			credentials: 'include',
			method: 'POST',
		});

		return { ...await parseBody(response), status: response.status };
	};
}

export class RemoteOAuthLoginToGameAction {
	private readonly baseUrl: string | null;

	constructor(baseUrl: string | null) {
		this.baseUrl = baseUrl;
	}

	action: OAuthLoginToGameAction = async (provider: string): Promise<OAuthLoginToGameResponse> => {
		const base: string = this.baseUrl || '';

		const response: Response = await fetch(`${base}/api/auth/${provider}/login-to-game`, {
			mode: 'cors',
			credentials: 'include',
			method: 'POST',
		});

		return { ...await parseBody(response), status: response.status };
	};
}
